
import React, { Component, Fragment } from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import { Typography, Grid } from '@material-ui/core'
import axios from 'axios'
import withRouter from 'react-router-dom/withRouter'
import getLoginId from '../../../utils/getLoginId'
import FileSaver from 'file-saver'
import { Link, Switch } from 'react-router-dom'
import { PrivateRoute } from '../../Router'


// calling server for updation
const DELETE_VEHICLE = gql`
  mutation excelFileUpload(
    $fileInfo: FileUploadInput!
    $commonInput: CommonInput!
  ) {
    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {
      failedToUpload
      totalExcelDataRecords
      totalDuplicateRecords
      successfullyUploaded
      failedUploadList
    }
  }
`
const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`
const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`
const styles = theme => ({
  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 2
  }
})

class DeleteBulkVehicle extends Component {
  state = {
    open: false,
    selectedFile: null,
    open1: false,
    vehicleProvider: '',
    uploadSucess: true,
    isVehicleProviderValid: false,
    response: '',
    failList: '',
    result: false,
    fileName: '',
    isLoading: false,
    disable: false
  }
  columns = ['Serial Number', 'Reason']

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15

  }
  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
  }
  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  handleOpenSelect = () => {
    this.setState({ open1: true })
  }
  handleCloseSelect = () => {
    this.setState({ open1: false })
  }
  checkVehicleProviderValidity = () => {
    this.setState({
      isVehicleProviderValid: this.state.vehicleProvider !== ''
    })
  }

  handleSubmit = client => async event => {
    event.preventDefault()
    this.setState({ isLoading: true, disable: true })
    const { data, errors } = await client.mutate({
      mutation: DELETE_VEHICLE,
      variables: {
        fileInfo: {
          uploadFor: 'deleteVehicles',
          bucketName: this.state.bucketName,
          fileName: this.state.fileName,
          operationType: 'SKIP'
        },
        commonInput: {
          clientLoginId: getLoginId()
        }
      },
      errorPolicy: 'all'
    })
    this.setState({ isLoading: false })
    // console.log("data-------->",data)
    if (data !== null) {
      let fullData = []

      let arrList = data.excelFileUpload.failedUploadList
      // console.log('arrList', JSON.parse(arrList))
      JSON.parse(arrList).forEach(element => {
        var rowData = []
        // this.clientId.push(element.id)
        rowData.push(element.serialNumber ? element.serialNumber : 'NA')
        rowData.push(element.errorMsg ? element.errorMsg : 'Invalid Serial Number')
        fullData.push(rowData)
      })

      this.setState({
        vehicleProvider: '',
        response:
          'Total Excel Records= ' +
          data.excelFileUpload.totalExcelDataRecords +
          ',' +
          'Total Records Uploaded=' +
          data.excelFileUpload.successfullyUploaded +
          ', Total Records Failed To Upload=' +
          data.excelFileUpload.failedToUpload +
          ', Total Duplicate Records in Excel=' +
          data.excelFileUpload.totalDuplicateRecords,
        uploadSucess: true,
        failList: fullData,
        result: true
      })
    } else {
      this.setState({ response: errors[0].message, uploadSucess: true })
    }
  }

  onUpload = async ({
    target: {
      validity,
      files: [file]
    }
  }) => {
    // TODO: Handle upload errors
    this.setState({ isUploading: true })
    if (validity.valid) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)

      const response = await this.props.client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: {
          fileExtension
        }
      })

      if (response.data && response.data.getPublicUploadURL) {
        const url = response.data.getPublicUploadURL.publicUploadURL
        await axios.put(url, file)

        this.setState({
          fileName: response.data.getPublicUploadURL.filename,
          bucketName: response.data.getPublicUploadURL.bucketName,
          publicUploadURL: response.data.getPublicUploadURL.publicUploadURL
        })
      }
    }

    this.setState({ isUploading: false, selectedFile: file.name })
  }

  downloadBulkDeassign = client => async event => {
    // console.log('click fun')
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'BulkDeleteVehicleTemplate .xlsx'
      },
      errorPolicy: 'all'
    })

    // console.log('file', data.getPublicDownloadURL)
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
    // FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
  }
  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={16}
        >
          <Grid item xs={12}>
            <Typography variant="headline">
              Upload Vehicle Details For Bulk Delete
            </Typography>
          </Grid>
          <form style={{ minWidth: '40%' }}>
            {this.state.uploadSucess && (
              <Typography variant="subheading" color="primary">
                {this.state.response}
              </Typography>
            )}
            <br />
            <br />
            <Grid xs={12}>
              Download sample template for Vehicle bulk delete
            </Grid>
            <Grid item xs={7}>
              <Button
                fullWidth
                color="secondary"
                variant="contained"
                className={classes.button}
                onClick={this.downloadBulkDeassign(this.props.client)}
              >
                Download Bulk Delete Excel
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Fragment>
                <br />
                <input
                  accept="*/*"
                  id="contained-button-file"
                  multiple
                  type="file"
                  style={{
                    display: 'none'
                  }}
                  onChange={this.onUpload}
                />
                <label htmlFor="contained-button-file">
                  Upload excel file here &nbsp;
                  <Button
                    variant="contained"
                    component="span"
                    color="primary"
                  >
                    {this.state.isUploading ? (
                      <CircularProgress size={15} />
                    ) : (
                      'Upload'
                    )}
                  </Button>
                </label>
                <span style={{ color: '#43a146' }}>
                  {this.state.selectedFile === null
                    ? '   No File Selected'
                    : '     ' + this.state.selectedFile}
                </span>

                <Typography variant="caption" color="textSecondary" gutterBottom>
                  File Format - XLS, XLSX
                </Typography>
              </Fragment>
            </Grid>
            <br />
            <br />
            <Button
              onClick={() => this.props.history.goBack()}
              color="default"
              variant="contained"
            // href={this.props.history.goBack()}
            >
              Cancel
            </Button>
            &nbsp; &nbsp;
            <Button
              onClick={this.handleSubmit(this.props.client)}
              color="primary"
              type="submit"
              variant="contained"
              disabled={!this.state.fileName || this.state.disable}
            >
              Submit
            </Button>{' '}
            {this.state.isLoading && (
              <h3>Excel sheet upload is in progress..</h3>
            )}
            {this.state.result && (
              <Grid item xs={12}>
                {/* TODO: Replace this with a custom table going forward */}
                <h5>Failed records list</h5>
                <MUIDataTable
                  data={this.state.failList}
                  columns={this.columns}
                  options={this.options}
                />
              </Grid>
            )}
          </form>
        </Grid>
      </div>
    )
  }
}

const WrappedDeleteBulkVehicle = withStyles(styles)(
  withRouter(withApollo(DeleteBulkVehicle))
)

export default props => (
  <Switch>
    <PrivateRoute
      exact
      path="/home/customer/vehicle/delete/bulk"
      render={props => <WrappedDeleteBulkVehicle {...props} />}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/BulkVehicleDelete.jsx